import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";
import { ProductVersionShippingPriceBracketModel } from "./ProductVersionShippingPriceBracketModel";

export class ProductVersionShippingOptionModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    tier: { label: "Tier", fieldType: "text" },
    minWeeks: { label: "Min Weeks", fieldType: "number", allowNull: true },
    maxWeeks: { label: "Max Weeks", fieldType: "number", allowNull: true },
    hideDelayAfter: {
      label: "Hide Delay After",
      fieldType: "number",
      allowNull: true,
    },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  tier!: string;
  minWeeks!: number | null;
  maxWeeks!: number | null;
  hideDelayAfter!: number | null;
  priceBrackets!: ProductVersionShippingPriceBracketModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("tier", "");
    this.defineObservableValue("minWeeks", null);
    this.defineObservableValue("maxWeeks", null);
    this.defineObservableValue("hideDelayAfter", null);
    this.defineObservableValue("priceBrackets", []);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product shipping option");
    this.tier = readString(source, "tier");
    this.minWeeks = readOptionalNumber(source, "minWeeks");
    this.maxWeeks = readOptionalNumber(source, "maxWeeks");
    this.hideDelayAfter = readOptionalNumber(source, "hideDelayAfter");
    this.priceBrackets = readObjectArray(source, "priceBrackets").map((entry) =>
      new ProductVersionShippingPriceBracketModel().restore(entry)
    );
    this.extra = splitKnown(source, [
      "tier",
      "minWeeks",
      "maxWeeks",
      "hideDelayAfter",
      "priceBrackets",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.tier ? { tier: this.tier } : {}),
      ...(this.minWeeks === null ? {} : { minWeeks: this.minWeeks }),
      ...(this.maxWeeks === null ? {} : { maxWeeks: this.maxWeeks }),
      ...(this.hideDelayAfter === null
        ? {}
        : { hideDelayAfter: this.hideDelayAfter }),
      ...(this.priceBrackets.length > 0
        ? { priceBrackets: this.priceBrackets.map((entry) => entry.save()) }
        : {}),
    };
  }
}
